import React from "react"
import { FaViber } from "react-icons/fa";

const ViberFloat = ({viber}) => (
  <a
    id="viberfloat"
    href={viber}
    className="float-button d-md-none"
    target="_blank"
    rel="noopener noreferrer nofollow"
  >
    <FaViber />
  </a>
)

ViberFloat.defaultProps = {
  viber: `viber://chat/?number=%2B380683328808`,
}

export default ViberFloat
